var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeAvatarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A1C311B3-D4C9-427D-A886-E1C163382CC7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "QA-|-Rebuttals",
    transform: "translate(-1527.000000, -596.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eye",
    transform: "translate(1527.000000, 596.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EBEBEE",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    rx: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.500784011,
    transform: "translate(10.000000, 13.000000)",
    fill: "#010101",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.84,14.28 C5.86,14.28 2.4,11.05 0.75,9.17 L0.75,9.17 C0.3,8.57 0,7.89 0,7.14 C0,6.39 0.3,5.64 0.75,5.11 C2.4,3.16 5.86,0 9.84,0 C13.82,0 17.28,3.23 18.93,5.11 L18.93,5.11 C19.38,5.71 19.68,6.39 19.68,7.14 C19.68,7.89 19.38,8.64 18.93,9.17 C17.28,11.05 13.9,14.28 9.84,14.28 Z M9.84,1.74 C6.53,1.74 3.6,4.6 2.1,6.25 C1.87,6.48 1.8,6.78 1.8,7.08 C1.8,7.38 1.88,7.68 2.1,7.91 C3.6,9.56 6.61,12.42 9.84,12.42 C13.15,12.42 16.08,9.56 17.58,7.91 C17.81,7.68 17.88,7.38 17.88,7.08 C17.88,6.78 17.8,6.48 17.58,6.25 C16.16,4.59 13.15,1.74 9.84,1.74 L9.84,1.74 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.84,10.68 C8.86,10.68 7.96,10.3 7.29,9.63 C6.61,8.95 6.24,8.05 6.24,7.08 C6.24,6.1 6.62,5.2 7.29,4.53 C7.97,3.85 8.87,3.48 9.84,3.48 C10.82,3.48 11.72,3.86 12.39,4.53 C13.07,5.21 13.44,6.11 13.44,7.08 C13.44,8.06 13.06,8.96 12.39,9.63 C11.72,10.3 10.82,10.68 9.84,10.68 Z M9.84,5.34 C9.39,5.34 8.94,5.57 8.56,5.87 C8.26,6.17 8.03,6.7 8.03,7.15 C8.03,7.6 8.26,8.05 8.56,8.43 C8.86,8.73 9.39,8.96 9.84,8.96 C10.29,8.96 10.74,8.73 11.12,8.43 C11.42,8.13 11.65,7.6 11.65,7.15 C11.65,6.7 11.42,6.25 11.12,5.87 C10.82,5.49 10.37,5.34 9.84,5.34 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeAvatarIcon);
export default __webpack_public_path__ + "static/media/eye-avatar-icon.a56cfb7ce8a9b5459b91c9bff9c9f6da.svg";
export { ForwardRef as ReactComponent };